import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse } from '../types/api';
import { TermsAcceptance } from '../types/TermsAcceptance';

const URL = '/v2/terms-acceptance';

class TermsAcceptanceService {
  static getByFilter(
    config?: AxiosRequestConfig
  ): Promise<PagedResponse<TermsAcceptance>> {
    return axios.get(URL, config);
  }

  static create(
    data: TermsAcceptance,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<TermsAcceptance>> {
    return axios.post(URL, data, config);
  }
}

export { TermsAcceptanceService };
